import React from 'react';
import ReportTable from "../../../hoc/ReportTable/ReportTable";
import { ReportSectionHeader } from "../SectionHeader";

const OfferingSeverityComponent = (props) => (

	<div>
		<ReportSectionHeader>
			<div id={"offeringSeverityStatTitle"} className={"SectionHeaderInner"}>
				{"Estimate of Maximum Potentially Available Section 11 Damages"}
			</div>
			
		</ReportSectionHeader>
		<ReportTable
			settings={[
				{
					header: 'Offering Date',
					accessor: 'date',
				},
				{
					header: 'Shares Issued~(000s)', 
					accessor: 'offeringShares',
					formatNumberWithCommas: true,
					inThousands: true,
					centerRightJustified: true,
					dollarValue: false,
					round2whole: true
				},
				{
					header: 'Shares Sold~(000s)', 
					accessor: 'soldShares',
					formatNumberWithCommas: true,
					inThousands: true,
					truncateDecimal: true,
					centerRightJustified: true
				},
				{
					header: 'Shares Retained~(000s)', 
					accessor: 'retainedShares',
					formatNumberWithCommas: true,
					inThousands: true,
					truncateDecimal: true,
					centerRightJustified: true
				},
				{
					header: 'Offering Price', 
					accessor: 'offeringPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Complaint Date Price', 
					accessor: 'complaintPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Price Decline Since Offering', 
					accessor: 'priceDecline',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Weighted Average Price of Sold Shares', 
					accessor: 'avgSoldPrice',
					dollarValue: true,
					formatNumberWithCommas: true,
					round2Decimals: true,
					centerRightJustified: true
				},
				{
					header: 'Damages on Shares Sold~(000s)', 
					accessor: 'soldSeverity',
					inThousands: true,
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true
				},
				{
					header: 'Damages on Shares Retained~(000s)', 
					accessor: 'retainedSeverity',
					inThousands: true,
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true
				},
				{
					header: 'Total Section 11 Damages~(000s)', 
					accessor: 'totalSeverity',
					inThousands: true,
					dollarValue: true,
					formatNumberWithCommas: true,
					truncateDecimal: true,
					centerRightJustified: true
				}
			]}
			data={props.offeringSeveritys}
			name={"offeringSeverity"}
            accumulatorDisplay={"Estimate of Maximum Potentially Available Section 11 Damages" }
            accumulator={"totalSeverity"}
		/>
	</div>
);


export default OfferingSeverityComponent;


// WEBPACK FOOTER //
// ./src/common/components/OfferingSeverity/OfferingSeverityComponent.js